import { IContentModel } from '@ninjacart/nc-nk-core';
import { normalizeTextContent } from '@ninjacart/nc-nk-store';
import { Text, XStack } from '@ninjacart/nc-nk-ui';
import { t } from 'i18next';
import { useRef, useState } from 'react';

export const ListTextContent = ({
  content,
  maxLength,
}: {
  content: IContentModel;
  maxLength: number;
}) => {
  const [showFullContent, setShowFullContent] = useState(false);
  const lastItemRef = useRef(content?.id);

  if (content.id !== lastItemRef?.current) {
    lastItemRef.current = content.id;
    setShowFullContent(false);
  }

  const trimNewlines = (input: string): string => {
    return input?.replace(/(\r\n|\n|\r)/gm, '')?.trim();
  };

  const fullTextContent = normalizeTextContent(
    trimNewlines(content?.description?.substring(0, 250)),
    true
  );

  const toggleExpansion = () => {
    setShowFullContent(!showFullContent);
  };

  return (
    <XStack>
      <Text
      testID="kisan_tId_toggleExpansion"
        padding={16}
        fontSize={14}
        lineHeight={22}
        color={'$color'}
        fontWeight={'500'}
        onPress={toggleExpansion}
      >
        {showFullContent ? fullTextContent : fullTextContent?.substring(0, 64)}
        {fullTextContent?.length > maxLength && (
          <Text color={'$primary'}>
            {showFullContent ? `${t('page.readLess')}` : `...${t('page.readMore')}`}
          </Text>
        )}
      </Text>
    </XStack>
  );
};
